import React, { useEffect } from 'react';
import { CertificateDecoder } from '../components/certificate-decoder/CertificateDecoder';

export const CertificateDecoderPage: React.FC = () => {
  useEffect(() => {
    document.title = "Certificate Decoder - WebDevToys";
  }, []);

  return (
    <div className="page-container">
      <CertificateDecoder />
    </div>
  );
};